/**
 * Base URLs for the ticketing backend.
 *
 * Services choose between these at runtime from the `Domain` value in
 * `sessionStorage`: the code `L` selects {@link environment.liveURL} and every
 * other domain code falls back to {@link environment.ticketAPI}.
 */
export const environment = {
    ticketAPI: 'https://ticketingtool-dev.teamleaseregtech.com/api',
    liveURL: 'https://ticketingtool.teamleaseregtech.com/api'
};